import React, { useEffect, useMemo, useState } from "react";
import { Chart } from "primereact/chart";
import { t } from "i18next";
import EventEmitter, { Events } from "../../services/eventemitter";

type DayWiseReport = {
    daydate: string;
    avgDayLoggedInTime: number;
};

type ChatAvailabilityProps = {
    dayWiseReportData: DayWiseReport[];
};

const ChatAvailability: React.FC<ChatAvailabilityProps> = React.memo(({ dayWiseReportData = [] }) => {

    const [avgLoggedTimeResponse, setAvgLoggedTimeResponse] = useState<number[]>([]);
    const [totalDays, setTotalDays] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [refreshState, setRefreshState] = useState<any>(new Date())

    useEffect(() => {
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, [])
    
    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }

    useEffect(() => {
        if (dayWiseReportData) {
            const daysArray = dayWiseReportData.map((element) => element.daydate);
            const avgLoggedTimeArray = dayWiseReportData.map(
                (element) => element.avgDayLoggedInTime
            );
            setTotalDays(daysArray);
            setAvgLoggedTimeResponse(avgLoggedTimeArray);
            setIsLoading(false);
        }
    }, [dayWiseReportData]);

    const stackedData = useMemo(() => {
        return {
            labels: totalDays,
            datasets: [
                {
                    type: "bar",
                    label: t('ReportComponent.Hours'),
                    backgroundColor: "#42A5F5",
                    data: avgLoggedTimeResponse,
                },
            ],
        };
    }, [totalDays, avgLoggedTimeResponse]);

    const getLightTheme = () => {
        let stackedOptions = {
            tooltips: {
                mode: "index",
                intersect: true,
            },
            responsive: true,
            legend: {
                labels: {
                    fontColor: "#495057",
                },
            },
        };

        return {
            stackedOptions,
        };
    };

    const { stackedOptions } = getLightTheme();

    return (
        <>{!isLoading && dayWiseReportData.length > 0 && (
            <div className="card">
                <h6>{t('ReportComponent.Chat Availability')}</h6>
                <Chart type="bar" data={stackedData} options={stackedOptions} />
            </div>
        )}
        </>
    );
});

export default ChatAvailability;
